import React, {useEffect} from 'react';
import { AllProducts, NavigationBar, CategoriesMenu } from '../components';


const ProductsList = () => {

    useEffect(() => {
        window.scrollTo(0,0)
    },[])


    return (
        <div>
            <div className='container'>
                <NavigationBar section='Products' goback={false} />

                    <AllProducts coltype={'col-md-4'} />           
            </div>
        </div>
    )
}

export default ProductsList;